import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";
import { Case } from "./case";
import { Worker } from "../../workers/_types/worker";
import { User } from "../../users/_types/user";
import { Task } from "../../tasks/_types/task";

export class CaseNote extends Resource {
    public override type = 'caseNotes';

    @prop()
    @required()
    public date: Date = new Date();

    @prop()
    @required()
    public source: string = "User";

    @prop()
    @required()
    public caseId!: string;

    public case!: Case;

    @prop()
    public workerId!: string;

    public worker!: Worker;

    @prop()
    public clientId!: string;

    public client!: Client;

    @prop()
    public userId!: string;

    public user!: User;

    @prop()
    public notes!: string;

    @prop()
    public caseNoteType!: string;

    @propObject(User)
    public createdByUser!: User;

    // Tareas asociadas a la nota (include 'tasks'); cada una con sus comentarios (include 'tasks.comments').
    public tasks!: Task[];
}